export const getCDbtStore = (store:string) => {
    const storeNumber = parseInt(store.replace("B",""));

    if(storeNumber >= 2 && storeNumber <= 399) {
      return ["B001", "B094", "B098", "B183", "B184", "B289"]
    } else if(storeNumber >= 501 && storeNumber <= 699) {
      return ["B504", "B529", "B552", "B607"]
    } else {
      return ["B703"]
    }
}
